/* eslint-env browser */
/* eslint-disable func-names */
/**
 * Webinar Series Component
 * Converted from jQuery to native JavaScript while preserving original behavior
 */
import { Component, registerComponent } from 'js/component.js';
import { hasDatePassed, formatIsoDateTime } from 'js/helpers.js';

const componentName = 'webinar-series';
const instanceName = 'webinar-instance';

export class WebinarSeries extends Component {

    /**
     * Initialize Component
     */
    init() {
        // Add sort-value attr to ul's (from sort-date attr in li)
        const webinarItems = document.querySelectorAll(`.${instanceName}__details`);
        webinarItems.forEach((webinarElement) => {
            const dateItem = webinarElement.querySelector(`.${instanceName}__startDate`);
            const timeItem = webinarElement.querySelector(`.${instanceName}__startTime`);
            const eventStart = dateItem.getAttribute('data-start-time');
            const eventEnd = dateItem.getAttribute('data-end-time');

            const {
                startDate, fullTimeString
            } = formatIsoDateTime(eventStart, eventEnd);

            // Inject date and time formats to match locale of current site
            const dateContent = dateItem.innerHTML;
            const timeContent = timeItem.innerHTML;
            const dateLabel = dateContent.substring(0, dateContent.lastIndexOf('/span>') + 6);
            const timeLabel = timeContent.substring(0, timeContent.lastIndexOf('/span>') + 6);

            dateItem.innerHTML = `${dateLabel} ${startDate}`;
            timeItem.innerHTML = `${timeLabel} ${fullTimeString}`;

            const webinarInstance = webinarElement.closest(`.${instanceName}`);
            if (webinarInstance) {
                const webinarHasPassed = hasDatePassed(eventEnd);
                webinarInstance.setAttribute('data-sort-status', webinarHasPassed ? 'on-demand' : 'upcoming');

                const sortVal = Date.parse(eventStart.substring(0, 16));
                webinarInstance.setAttribute('data-sort-value', sortVal);
            }
        });

        // Order webinars by date
        const webinarList = document.querySelector('.series-instances');
        const webinars = Array.from(document.querySelectorAll('.webinar-instance[data-sort-value]'));

        // Sort webinars by sort-value (same logic as jQuery version)
        webinars.sort((a, b) => {
            const aValue = parseInt(a.dataset.sortValue, 10);
            const bValue = parseInt(b.dataset.sortValue, 10);
            return aValue - bValue;
        });

        // Prepend sorted webinars to webinar list (same as jQuery prependTo)
        webinars.forEach((webinar) => {
            if (webinarList && webinarList.contains(webinar)) {
                webinarList.removeChild(webinar);
            }
        });
        webinars.forEach((webinar) => {
            if (webinarList) {
                webinarList.insertBefore(webinar, webinarList.firstChild);
            }
        });

        // Display future webinars first (upcoming) then past webinars (on-demand)
        const pastWebinars = Array.from(document.querySelectorAll('.webinar-instance[data-sort-status="on-demand"]'));
        const futureWebinars = Array.from(document.querySelectorAll('.webinar-instance[data-sort-status="upcoming"]'));

        // Prepend past webinars first (so they end up after future webinars)
        pastWebinars.forEach((webinar) => {
            if (webinarList && webinarList.contains(webinar)) {
                webinarList.removeChild(webinar);
            }
        });
        pastWebinars.forEach((webinar) => {
            if (webinarList) {
                webinarList.insertBefore(webinar, webinarList.firstChild);
            }
        });

        // Then prepend future webinars (so they end up first)
        futureWebinars.forEach((webinar) => {
            if (webinarList && webinarList.contains(webinar)) {
                webinarList.removeChild(webinar);
            }
        });
        futureWebinars.forEach((webinar) => {
            if (webinarList) {
                webinarList.insertBefore(webinar, webinarList.firstChild);
            }
        });
    }
}

registerComponent(`.${componentName}`, WebinarSeries);
